export class PACycleRequestModel {
    constructor() {
        this.cycleName = "";
        this.employeeName = "";
        this.year = "";
        this.pmoTeamId = null;
        this.teamName = "All";
        this.status = "All";
    }
}
export default class CycleSearch extends PACycleRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
